<div class="card trending-menus">
    <fo-card-title [title]="title" [subTitle]="subTitle"></fo-card-title>
    <div class="card-body ">
        <div class="dz-scroll height500">
            <app-restaurant-trending-list-item *ngFor="let restaurant of restaurants;let i = index" [restaurant]="restaurant" [ranking]="i+1">
            </app-restaurant-trending-list-item>
        </div>
    </div>
</div>